const SITE_URL = (process.env.VUE_APP_SITE_URL || 'https://www.aghsolarboat.pl').replace(/\/$/, '')

const ROUTE_SEO_KEYS = {
  welcome: 'welcome',
  about: 'about',
  team: 'team',
  recruitment: 'recruitment',
  contact: 'contact',
  achievements: 'achievements',
  competitions: 'competitions',
  grants: 'grants'
}

function upsertMeta(attrName, attrValue, content) {
  let el = document.querySelector(`meta[${attrName}="${attrValue}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attrName, attrValue)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function upsertLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`)
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', rel)
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

function resolveMeta(route, i18n) {
  const routeKey = ROUTE_SEO_KEYS[route.name] || 'default'

  const title = i18n.te(`seo.routes.${routeKey}.title`)
    ? i18n.t(`seo.routes.${routeKey}.title`)
    : i18n.t('seo.routes.default.title')

  const description = i18n.te(`seo.routes.${routeKey}.description`)
    ? i18n.t(`seo.routes.${routeKey}.description`)
    : i18n.t('seo.routes.default.description')

  return { title, description }
}

export function applyRouteMeta(route, vm) {
  if (!vm || !vm.$i18n) return

  const { title, description } = resolveMeta(route, vm.$i18n)
  const canonicalPath = route.path.endsWith('/') && route.path.length > 1
    ? route.path.slice(0, -1)
    : route.path
  const canonicalUrl = `${SITE_URL}${canonicalPath === '' ? '/' : canonicalPath}`
  const ogLocale = vm.$i18n.locale === 'en' ? 'en_US' : 'pl_PL'

  document.title = title
  document.documentElement.lang = vm.$i18n.locale === 'en' ? 'en' : 'pl'

  upsertMeta('name', 'description', description)
  upsertMeta('property', 'og:title', title)
  upsertMeta('property', 'og:description', description)
  upsertMeta('property', 'og:url', canonicalUrl)
  upsertMeta('property', 'og:type', 'website')
  upsertMeta('property', 'og:site_name', vm.$i18n.t('seo.site_name'))
  upsertMeta('property', 'og:locale', ogLocale)
  upsertMeta('name', 'twitter:card', 'summary_large_image')
  upsertMeta('name', 'twitter:title', title)
  upsertMeta('name', 'twitter:description', description)

  upsertLink('canonical', canonicalUrl)
}

export { SITE_URL }
